export default "__VITE_ASSET__a5p1icT___"